export const NAMESPACE = 'user';
